import type {
  ModalCopy,
  ModalCopyType,
} from "@circle-react-shared/TrixEditor/InlineModalSelector/ModalCopy";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";

const PROVIDER_SUBTYPES: ModalCopyType[] = [
  "youtube",
  "wistia",
  "vimeo",
  "loom",
  "soundcloud",
  "spotify",
  "simplecast",
  "instagram",
  "facebook",
  "twitter",
  "typeform",
  "airtable",
  "videoask",
  "github",
  "googlemaps",
  "codepen",
];

export const isProviderSubtype = (subtype?: ModalCopyType) =>
  !!subtype && PROVIDER_SUBTYPES.includes(subtype);

const ProvidersLink = ({ children }: { children: ReactNode }) => (
  <a href="https://iframely.com/domains" target="_blank" rel="noreferrer">
    {children}
  </a>
);

export const getEmbedDescription = (
  subtype: ModalCopyType | undefined,
  copy: ModalCopy,
): ReactNode => {
  if (isProviderSubtype(subtype)) {
    return (
      <>
        {t("tiptap.extensions.embed.provider_description.works_with", {
          provider: copy.itemName,
        })}
        <ProvidersLink>
          {t("tiptap.extensions.embed.provider_description.providers")}
        </ProvidersLink>
      </>
    );
  }

  if (!subtype || subtype === "embed") {
    return (
      <>
        {t("tiptap.extensions.embed.description.start")}
        <ProvidersLink>
          {t("tiptap.extensions.embed.description.providers")}
        </ProvidersLink>
        {t("tiptap.extensions.embed.description.end")}
      </>
    );
  }

  return <>{copy.embedDesc || copy.helperText}</>;
};
